import React, { useEffect, useState } from "react";
import { FiX } from "react-icons/fi";
import classes from "./EditProductModal.module.css";
import ImageUpload from "../../../components/ImageUpload";
import API from "../../../utils/api";
import RenderToast from "../../../components/RenderToast";
import { PLACEHOLDER_IMAGE } from "../../../utils/image";

export default function EditProductModal({
  product,
  onClose,
  onUpdated,
  getImageUrl,
  brands = [],
  categories = [],
}) {
  const [editProduct, setEditProduct] = useState(null);
  const [editProductImage, setEditProductImage] = useState(null);
  const [editProductImagePreview, setEditProductImagePreview] = useState(null);
  const [editProductGallery, setEditProductGallery] = useState([]);
  const [submitting, setSubmitting] = useState(false);
  const [deletedGalleryImages, setDeletedGalleryImages] = useState([]);

  useEffect(() => {
    if (!product) return;

    setEditProduct({
      id: product.id,
      sku: product.sku,
      productName: product.productName,
      productShortDesc: product.productShortDesc,
      productDesc: product.productDesc,
      brand_id: product.brand_id || "",
      category_id: product.category_id || "",
      inStock: product.inStock || "",
      metaTitle: product.metaTitle || "",
      metaDescription: product.metaDescription || "",
      condition: product.condition || "",
      regularPrice: product.regularPrice || "",
      salePrice: product.salePrice || "",
      status: product.status || "draft",
    });

    setEditProductImagePreview(
      product.productImage
        ? getImageUrl(product.productImage)
        : PLACEHOLDER_IMAGE
    );

    if (product.productGallery) {
      try {
        const gallery =
          typeof product.productGallery === "string"
            ? JSON.parse(product.productGallery)
            : product.productGallery;
        if (Array.isArray(gallery)) {
          const existingItems = gallery.map((img) => ({
            file: null,
            preview: getImageUrl(img),
          }));
          setEditProductGallery(existingItems);
        }
      } catch {
        setEditProductGallery([]);
      }
    }

    setEditProductImage(null);
    // setEditProductGallery([]); // already set above
  }, [product, getImageUrl]);

  const handleChange = (field, value) => {
    setEditProduct((prev) => ({ ...prev, [field]: value }));
  };

  const handleEditImageChange = (file) => {
    setEditProductImage(file);
    const reader = new FileReader();
    reader.onloadend = () => setEditProductImagePreview(reader.result);
    reader.readAsDataURL(file);
    // Clear the removed flag since we're uploading a new image
    setEditProduct((prev) => ({
      ...prev,
      productImageRemoved: false,
    }));
  };

  // const removeEditProductImage = () => {
  //   setEditProductImage(null);
  //   setEditProductImagePreview(null);
  // };

  const removeEditProductImage = () => {
    setEditProductImage(null);
    setEditProductImagePreview(PLACEHOLDER_IMAGE); // show placeholder
    setEditProduct((prev) => ({
      ...prev,
      productImageRemoved: true, // signal backend to remove
    }));
  };
  // const handleEditGalleryChange = async (files) => {
  //   if (!files) return;
  //   const fileArray = Array.isArray(files) ? files : [files];
  //   const limitedFiles = fileArray.slice(0, 5);
  //   setEditProductGallery(limitedFiles);

  //   const previews = [];
  //   let loadedCount = 0;
  //   limitedFiles.forEach((file, index) => {
  //     const reader = new FileReader();
  //     reader.onloadend = () => {
  //       previews[index] = reader.result;
  //       loadedCount++;
  //       if (loadedCount === limitedFiles.length) {
  //         setEditProductGalleryPreviews((prev) => [
  //           ...(prev || []),
  //           ...previews.filter(Boolean),
  //         ]);
  //       }
  //     };
  //     reader.readAsDataURL(file);
  //   });
  // };

  const handleEditGalleryChange = async (files) => {
    if (!files) return;
    const fileArray = Array.isArray(files) ? files : [files];
    const availableSlots = 5 - editProductGallery.length;
    const limitedFiles = fileArray.slice(0, Math.max(0, availableSlots));

    if (limitedFiles.length === 0) return;

    const newItems = await Promise.all(
      limitedFiles.map(
        (file) =>
          new Promise((resolve) => {
            const reader = new FileReader();
            reader.onloadend = () => resolve({ file, preview: reader.result });
            reader.readAsDataURL(file);
          })
      )
    );
    setEditProductGallery((prev) => [...prev, ...newItems]);
  };

  // const removeEditGalleryImage = (index) => {
  //   setEditProductGalleryPreviews((prev) => prev.filter((_, i) => i !== index));
  //   if (index < editProductGallery.length) {
  //     setEditProductGallery((prev) => prev.filter((_, i) => i !== index));
  //   }
  // };

  const removeEditGalleryImage = (index) => {
    const removedItem = editProductGallery[index];
    if (removedItem) {
      if (removedItem.file === null) {
        // Existing image, add to deleted list
        setDeletedGalleryImages((prev) => [...prev, removedItem.preview]);
      }
      // Remove from gallery
      setEditProductGallery((prev) => prev.filter((_, i) => i !== index));
    }
  };

  // const handleSubmit = async (e) => {
  //   e.preventDefault();
  //   if (!editProduct) return;
  //   setSubmitting(true);

  //   try {
  //     const token = localStorage.getItem("authToken");
  //     const formData = new FormData();
  //     formData.append("action", "update");
  //     formData.append("id", editProduct.id);
  //     formData.append("sku", editProduct.sku);
  //     formData.append("product_name", editProduct.productName);
  //     formData.append(
  //       "product_short_description",
  //       editProduct.productShortDesc || ""
  //     );
  //     formData.append("product_description", editProduct.productDesc || "");
  //     formData.append("product_brand", editProduct.brand_id || "");
  //     formData.append("product_category", editProduct.category_id || "");
  //     formData.append("product_stocks", editProduct.inStock || "");
  //     formData.append("product_meta_title", editProduct.metaTitle || "");
  //     formData.append(
  //       "product_meta_description",
  //       editProduct.metaDescription || ""
  //     );
  //     formData.append("product_condition", editProduct.condition || "");
  //     formData.append("regular_price", editProduct.regularPrice || "");
  //     formData.append("sale_price", editProduct.salePrice || "");
  //     formData.append("product_status", editProduct.status || "draft");

  //     // if (editProductImage) formData.append("product_image", editProductImage);

  //     // Main image
  //     if (editProductImage) {
  //       formData.append("product_image", editProductImage);
  //     } else if (editProduct?.productImageRemoved) {
  //       formData.append("product_image", ""); // signal backend to delete
  //     }

  //     // Gallery images
  //     editProductGallery.forEach((f) =>
  //       formData.append("product_gallery[]", f)
  //     );

  //     // Deleted gallery images
  //     deletedGalleryImages.forEach((img) =>
  //       formData.append("deleted_gallery_images[]", img)
  //     );

  //     const response = await fetch(`${API.base}/products.php`, {
  //       method: "POST",
  //       headers: { Authorization: token },
  //       body: formData,
  //     });

  //     const data = await response.json();
  //     if (data.success) {
  //       RenderToast({
  //         type: "success",
  //         message: "Product updated successfully!",
  //       });
  //       onUpdated?.();
  //     } else {
  //       RenderToast({ type: "error", message: data.error || "Update failed" });
  //     }
  //   } catch {
  //     RenderToast({ type: "error", message: "Network error. Try again." });
  //   } finally {
  //     setSubmitting(false);
  //   }
  // };

  // --- SUBMIT HANDLER ---
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!editProduct) return;

    // Validate sale price must be lower than regular price
    const regularPrice = parseFloat(editProduct.regularPrice) || 0;
    const salePrice = parseFloat(editProduct.salePrice) || 0;
    if (salePrice > 0 && regularPrice > 0 && salePrice >= regularPrice) {
      RenderToast({
        type: "error",
        message: "Sale price must be lower than regular price",
      });
      return;
    }

    setSubmitting(true);

    try {
      const token = localStorage.getItem("authToken");
      const formData = new FormData();
      formData.append("action", "update");
      formData.append("id", editProduct.id);
      formData.append("sku", editProduct.sku);
      formData.append("product_name", editProduct.productName);
      formData.append(
        "product_short_description",
        editProduct.productShortDesc || ""
      );
      formData.append("product_description", editProduct.productDesc || "");
      formData.append("product_brand", editProduct.brand_id || "");
      formData.append("product_category", editProduct.category_id || "");
      formData.append("product_stocks", editProduct.inStock || "");
      formData.append("product_meta_title", editProduct.metaTitle || "");
      formData.append(
        "product_meta_description",
        editProduct.metaDescription || ""
      );
      formData.append("product_condition", editProduct.condition || "");
      formData.append("regular_price", editProduct.regularPrice || "");
      formData.append("sale_price", editProduct.salePrice || "");
      formData.append("product_status", editProduct.status || "draft");

      // --- MAIN IMAGE ---
      if (editProductImage) {
        formData.append("product_image", editProductImage);
      } else if (editProduct?.productImageRemoved) {
        // send empty string to remove existing image
        formData.append("product_image", "");
      }

      // --- GALLERY IMAGES ---
      editProductGallery.forEach((item) => {
        if (item.file) {
          formData.append("product_gallery[]", item.file);
        }
      });

      // --- DELETED GALLERY IMAGES ---
      deletedGalleryImages.forEach((img) =>
        formData.append("deleted_gallery_images[]", img)
      );

      const response = await fetch(`${API.base}/products.php`, {
        method: "POST",
        headers: { Authorization: token },
        body: formData,
      });

      const data = await response.json();
      if (data.success) {
        RenderToast({
          type: "success",
          message: "Product updated successfully!",
        });
        onUpdated?.();
      } else {
        RenderToast({ type: "error", message: data.error || "Update failed" });
      }
    } catch (err) {
      console.error(err);
      RenderToast({ type: "error", message: "Network error. Try again." });
    } finally {
      setSubmitting(false);
    }
  };
  if (!product) return null;

  return (
    <div className={classes.modalOverlay} role="dialog" aria-modal="true">
      <div className={classes.modal}>
        <header className={classes.modalHeader}>
          <h4>Edit Product</h4>
          <button className={classes.closeBtn} onClick={onClose}>
            <FiX />
          </button>
        </header>

        <form className={classes.content} onSubmit={handleSubmit}>
          {/* Product Image */}
          <div className={classes.imageRow}>
            <ImageUpload
              label="Product Image"
              onImageChange={handleEditImageChange}
              onRemove={removeEditProductImage}
              preview={editProductImagePreview}
              multiple={false}
            />
          </div>

          {/* Details Grid */}
          <div className={classes.detailsGrid}>
            {/* Half width fields */}
            <div className={classes.halfWidth}>
              <label>SKU</label>
              <input
                value={editProduct?.sku || ""}
                onChange={(e) => handleChange("sku", e.target.value)}
              />
            </div>
            <div className={classes.halfWidth}>
              <label>Brand</label>
              <select
                value={editProduct?.brand_id || ""}
                onChange={(e) => handleChange("brand_id", e.target.value)}
              >
                <option value="">Select Brand</option>
                {brands.map((b) => (
                  <option key={b.id} value={b.id}>
                    {b.brandName}
                  </option>
                ))}
              </select>
            </div>

            <div className={classes.halfWidth}>
              <label>Category</label>
              <select
                value={editProduct?.category_id || ""}
                onChange={(e) => handleChange("category_id", e.target.value)}
              >
                <option value="">Select Category</option>
                {categories.map((c) => (
                  <option key={c.id} value={c.id}>
                    {c.categoryName}
                  </option>
                ))}
              </select>
            </div>
            <div className={classes.halfWidth}>
              <label>Status</label>
              <select
                value={editProduct?.status || "draft"}
                onChange={(e) => handleChange("status", e.target.value)}
              >
                <option value="draft">Draft</option>
                <option value="publish">Publish</option>
              </select>
            </div>
            <div className={classes.halfWidth}>
              <label>Condition</label>
              <select
                value={editProduct?.condition || ""}
                onChange={(e) => handleChange("condition", e.target.value)}
              >
                <option value="">Select Condition</option>
                <option value="new">New</option>
                <option value="refurbished">Refurbished</option>
                <option value="used">Used</option>
              </select>
            </div>

            <div className={classes.halfWidth}>
              <label>Regular Price</label>
              <input
                type="number"
                value={editProduct?.regularPrice || ""}
                onChange={(e) => handleChange("regularPrice", e.target.value)}
              />
            </div>
            <div className={classes.halfWidth}>
              <label>Sale Price</label>
              <input
                type="number"
                value={editProduct?.salePrice || ""}
                onChange={(e) => handleChange("salePrice", e.target.value)}
              />
            </div>

            {/* Full width fields */}
            <div className={classes.fullWidth}>
              <label>Stock</label>
              <input
                type="number"
                value={editProduct?.inStock || ""}
                onChange={(e) => handleChange("inStock", e.target.value)}
              />
            </div>

            <div className={classes.fullWidth}>
              <label>Product Name</label>
              <input
                value={editProduct?.productName || ""}
                onChange={(e) => handleChange("productName", e.target.value)}
              />
            </div>

            <div className={classes.fullWidth}>
              <label>Short Description</label>
              <textarea
                value={editProduct?.productShortDesc || ""}
                onChange={(e) =>
                  handleChange("productShortDesc", e.target.value)
                }
              />
            </div>

            <div className={classes.fullWidth}>
              <label>Description</label>
              <textarea
                value={editProduct?.productDesc || ""}
                onChange={(e) => handleChange("productDesc", e.target.value)}
              />
            </div>

            <div className={classes.fullWidth}>
              <label>Meta Title</label>
              <input
                value={editProduct?.metaTitle || ""}
                onChange={(e) => handleChange("metaTitle", e.target.value)}
              />
            </div>

            <div className={classes.fullWidth}>
              <label>Meta Description</label>
              <textarea
                value={editProduct?.metaDescription || ""}
                onChange={(e) =>
                  handleChange("metaDescription", e.target.value)
                }
              />
            </div>
          </div>

          {/* Gallery */}
          <div className={classes.galleryRow}>
            <ImageUpload
              label="Product Gallery (Max 5)"
              onImageChange={handleEditGalleryChange}
              onRemove={removeEditGalleryImage}
              preview={editProductGallery.map((item) => item.preview)}
              multiple={true}
              maxFiles={5}
            />
          </div>

          <footer className={classes.modalFooter}>
            <button type="button" className={classes.cancel} onClick={onClose}>
              Cancel
            </button>
            <button
              type="submit"
              className={classes.primary}
              disabled={submitting}
            >
              {submitting ? "Updating..." : "Update"}
            </button>
          </footer>
        </form>
      </div>
    </div>
  );
}